
export const isValidEmailWithWebsiteDomain = (email: string | undefined, companyWebsite: string | undefined) : boolean => {
  if (email === undefined || companyWebsite === undefined) return false;

  let parts = email.split('@');
  if (parts.length < 2) {
    return false;
  }
  return companyWebsite.includes(parts[1]);
};